import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class GlobalService {
  private headerShow: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );
  private spinnerShow: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private bookingButtonShow: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );

  get isHeaderShow() {
    return this.headerShow.asObservable();
  }

  get isSpinnerShow() {
    return this.spinnerShow.asObservable();
  }

  get isBookingButtonShow() {
    return this.bookingButtonShow.asObservable();
  }

  hideHeader() {
    this.headerShow.next(false);
  }

  showHeader() {
    this.headerShow.next(true);
  }

  hideSpinner() {
    this.spinnerShow.next(false);
  }

  showSpinner() {
    this.spinnerShow.next(true);
  }

  hideBookingButton() {
    this.bookingButtonShow.next(false);
  }

  showBookingButton() {
    this.bookingButtonShow.next(true);
  }
}
